"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25260],{

/***/ 119198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useBottomButtons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(916476);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(314408);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47649);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(141873);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(446586);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534090);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









const useBottomButtons = ()=>{
    const { allowBuyNow  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { product , price , payloadAddToCart , isCanAddToCard , stockAvailable , primitiveProduct , selectedPromotion ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useProductDetailState */ .W)();
    const showToast = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .useToast */ .p)();
    const { onAddSingleItem  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const onAddItemToCart = async (type)=>{
        var ref, ref1;
        if (!isCanAddToCard) {
            var ref2;
            (ref2 = showToast.info) === null || ref2 === void 0 ? void 0 : ref2.call(showToast, {
                title: "",
                message: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Chỉ c\xf2n {{stockAvailable}} sản phẩm", {
                    stockAvailable
                }),
                type: "error",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CautionOutlined */ .s, {
                    size: 50,
                    color: "#E24C4B"
                })
            });
            return;
        }
        if (!primitiveProduct) return;
        // params send to Teko tracking in event addToCart
        const trackAddToCartParams = {
            product: {
                sku: (product === null || product === void 0 ? void 0 : product.sellerSku) || "",
                name: (product === null || product === void 0 ? void 0 : product.name) || "",
                brand: product === null || product === void 0 ? void 0 : product.brand,
                categories: product === null || product === void 0 ? void 0 : product.categories,
                price: parseFloat((product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : (ref1 = ref.supplierRetailPrice) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"),
                addToCartPrice: (price === null || price === void 0 ? void 0 : price.finalPrice) || 0,
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            },
            selectedPromotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
            type
        };
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return;
            const res = await onAddSingleItem({
                sku: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku,
                promotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
                quantity: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity,
                isPrimary: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.isPrimary
            }, false, allowBuyNow && type === _teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.BUYNOW */ .h.BUYNOW ? _teko_cart_v2__WEBPACK_IMPORTED_MODULE_10__/* .IsolatedCartType.BUY_NOW */ .oG.BUY_NOW : undefined);
            if (res) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }));
            } else {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }));
            }
            if (res && (type === _teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.BUYNOW */ .h.BUYNOW || type === _teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT)) {
                if (type === _teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.BUYNOW */ .h.BUYNOW && !allowBuyNow) {
                    router.push("/cart");
                } else {
                    const key = (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_10__/* .getBuyNowKey */ .B2)(true);
                    router.push("/checkout?bnk=".concat(key));
                }
            }
        } catch (e) {
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }));
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
        }
    };
    const onBuy = ()=>{
        onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART);
    };
    const onBuyNow = ()=>{
        onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .AddToCartType.BUYNOW */ .h.BUYNOW);
    };
    return {
        onBuy,
        onBuyNow
    };
};


/***/ }),

/***/ 199184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useProductRecipes; }
/* harmony export */ });
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185081);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(534924);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88837);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);




const useProductRecipes = ()=>{
    const { 0: selectedRecipe , 1: setSelectedRecipe  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { product: { cookingRecipes =[]  } = {}  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useProductDetailState */ .W)();
    const materialSkus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref;
        if (selectedRecipe) return (ref = selectedRecipe.ingredients) === null || ref === void 0 ? void 0 : ref.map((item)=>item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.url
    ]);
    const { result: { products: materialProducts  } ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSearch */ .Rx)((materialSkus === null || materialSkus === void 0 ? void 0 : materialSkus.length) ? {
        page: 1,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_3__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl,
        filter: {
            skus: materialSkus
        }
    } : {});
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!!cookingRecipes && Array.isArray(cookingRecipes) && !!cookingRecipes.length) {
            setSelectedRecipe(cookingRecipes[0]);
        }
    }, [
        cookingRecipes
    ]);
    const orderedMaterials = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const selectedIngredients = (selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.ingredients) || [];
        if (!selectedIngredients.length) return undefined;
        return [
            ...materialProducts
        ].sort((a, b)=>selectedIngredients.findIndex((i)=>i === a.sku) - selectedIngredients.findIndex((i)=>i === b.sku));
    }, [
        selectedRecipe,
        materialProducts
    ]);
    return {
        cookingRecipes,
        selectedRecipe,
        setSelectedRecipe,
        materialProducts,
        orderedMaterials
    };
};


/***/ }),

/***/ 575771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PaymentPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831026);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640793);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(587021);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(517844);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border: 1px solid;\n  border-color: ",
        ";\n  border-radius: 8px;\n  background-color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px;\n  background-color: #f5f5f5;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 4px;\n  font-size: 15px;\n  font-weight: 500;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px;\n  padding-top: 0;\n\n  > div[type='line'] {\n    margin-bottom: 8px;\n    gap: 16px;\n\n    > div[type='line'] {\n      padding: 0;\n    }\n\n    &::after {\n      width: 48px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  ul {\n    padding-left: 2rem;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  font-size: 13px;\n  line-height: 20px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





const PaymentPromotion = ()=>{
    const LOGO_DIMENSION = 48;
    const { paymentPromotions =[] , isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    if (!(paymentPromotions === null || paymentPromotions === void 0 ? void 0 : paymentPromotions.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledShape, {
        margin: [
            "s16",
            "s0"
        ],
        marginTop: isMobile ? "s16" : "s8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledHeaderContent, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .GreenGiffColored */ .f, {
                        size: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledTitle, {
                        children: [
                            " ",
                            (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Ưu đ\xe3i thanh to\xe1n")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTabs, {
                children: paymentPromotions.map((item)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .TabItem */ .E, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                            src: item.logoUrl,
                            alt: item.altLogo || item.logoUrl,
                            width: LOGO_DIMENSION
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContent, {
                                dangerouslySetInnerHTML: {
                                    __html: item.content || ""
                                }
                            }),
                            item.expirationDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledExpirationDate, {
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("HSD:"),
                                    " ",
                                    item.expirationDate
                                ]
                            })
                        ]
                    }, item.logoUrl);
                })
            })
        ]
    });
};
const StyledShape = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.border;
});
const StyledHeaderContent = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject1());
const StyledTitle = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Title */ .Dx)(_templateObject2());
const StyledTabs = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Tabs */ .m)(_templateObject3());
const StyledContent = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject4());
const StyledExpirationDate = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.textSecondary;
});


/***/ }),

/***/ 589043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Policies; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UpOutlined.es.js
var UpOutlined_es = __webpack_require__(994734);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./modules/product-detail/shared/PolicyAndService.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  background-color: #fff;\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  & > * {\n    margin: 0;\n  }\n  line-height: 22px;\n  font-size: 14px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






const PolicyAndService = (_param)=>{
    var { title , information , max =4 , columns =2 , showText =(0,i18n.t)("Xem th\xeam") , hideText =(0,i18n.t)("R\xfat gọn")  } = _param, rest = _objectWithoutProperties(_param, [
        "title",
        "information",
        "max",
        "columns",
        "showText",
        "hideText"
    ]);
    const theme = (0,Theme_es/* useTheme */.F)();
    const { 0: maxItems , 1: setMaxItems  } = (0,react.useState)(max);
    // map data based on max items allow to display
    const displayInformation = maxItems < information.length ? information.slice(0, maxItems) : information;
    // calculate number of rows to display
    const numberOfRows = Math.round(displayInformation.length / columns);
    const minRows = Math.round(max / columns);
    // split display data into arrays size of display columns
    const displayItems = [];
    for(let index = 0; index < numberOfRows; index++){
        displayItems.push(displayInformation.slice(index * columns, (index + 1) * columns));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                level: 2,
                weight: "medium",
                marginBottom: "s12",
                style: {
                    fontSize: "15px",
                    lineHeight: "24px",
                    color: "rgba(0, 0, 0, 0.88)"
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                paddingBottom: "s8",
                children: displayItems.map((displayItem, displayItemIndex)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                        marginBottom: displayItemIndex < displayItems.length - 1 ? "s8" : undefined,
                        justify: "space-between",
                        style: {
                            gap: "20px"
                        },
                        className: "test-row",
                        children: displayItem.map((item, itemIndex)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                width: displayItems.length === 1 ? "100%" : "calc(50% - 10px)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyItem, {
                                    children: [
                                        typeof item.icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                                            width: 24,
                                            height: 24,
                                            src: item.icon
                                        }) : item.icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                            dangerouslySetInnerHTML: {
                                                __html: purify_default().sanitize(item.content || "", {
                                                    ALLOWED_ATTR: [
                                                        "target",
                                                        "href"
                                                    ]
                                                })
                                            }
                                        })
                                    ]
                                })
                            }, itemIndex);
                        })
                    }, displayItemIndex);
                })
            }),
            maxItems < information.length || numberOfRows > minRows ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                justify: "center",
                marginTop: "s8",
                children: maxItems < information.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlexWrapper, {
                    align: "center",
                    gap: "s4",
                    onClick: ()=>{
                        setMaxItems(information.length);
                    },
                    children: [
                        showText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                            size: 16,
                            color: theme.colors.primary
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlexWrapper, {
                    align: "center",
                    gap: "s4",
                    onClick: ()=>{
                        setMaxItems(max);
                    },
                    children: [
                        hideText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined_es/* UpOutlined */.X, {
                            size: 16,
                            color: theme.colors.primary
                        })
                    ]
                })
            }) : null
        ]
    }));
};
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject(), BaseProps_index_es/* CommonStyles */.F);
const PolicyItem = emotion_styled_browser_esm["default"].div(_templateObject1());
const Content = emotion_styled_browser_esm["default"].div(_templateObject2());
const StyledIcon = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)(_templateObject3());
const StyledFlexWrapper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)((param)=>{
    let { theme  } = param;
    return "\n  cursor: pointer;\n  background-color: unset;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary, ";\n  font-size: 13px;\n  border: 0px;\n  &:focus {\n    border: 0px;\n    outline: 0px;\n  }\n");
});

// EXTERNAL MODULE: ./hooks/usePolicies.tsx + 1 modules
var usePolicies = __webpack_require__(691018);
;// CONCATENATED MODULE: ./modules/product-detail/shared/Policies.tsx







const Policies = ()=>{
    var ref;
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { salePolicies , otherPolicies  } = (0,usePolicies/* usePolicies */.D)((product === null || product === void 0 ? void 0 : product.sku) || "", product === null || product === void 0 ? void 0 : (ref = product.seller) === null || ref === void 0 ? void 0 : ref.id);
    if (!product && !(salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) && !(otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
        paddingTop: "s8",
        children: (salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) || (otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
            backgroundColor: "white",
            children: [
                (salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyAndService, {
                    title: (0,i18n.t)("Ch\xednh s\xe1ch b\xe1n h\xe0ng"),
                    information: salePolicies,
                    padding: "s8"
                }) : null,
                (otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyAndService, {
                    title: (0,i18n.t)("Dịch vụ kh\xe1c"),
                    information: otherPolicies,
                    padding: "s8"
                }) : null
            ]
        }) : null
    });
};


/***/ }),

/***/ 326557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ProductInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(825078);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(723357);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534924);
/* harmony import */ var helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(347822);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  margin: 0;\n  line-height: 24px;\n  text-align: left;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  & > a,\n  span {\n    font-size: 13px;\n    line-height: 20px;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  color: #000000a6;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: ",
        ";\n  flex-direction: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









const shortenString = function(name) {
    let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var ref;
    const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
    if (!trimmedName) return "";
    if (trimmedName.length <= maxLength) return trimmedName;
    return "".concat((ref = trimmedName.slice(0, maxLength)) === null || ref === void 0 ? void 0 : ref.trimEnd(), "...");
};
const ProductBrand = (param)=>{
    let { brandCode , brandName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: {
            pathname: "/brands/[brandId]",
            query: {
                brandId: brandCode
            }
        },
        as: {
            pathname: "/".concat(brandCode, "-brand.").concat(brandCode)
        },
        shallow: true,
        passHref: true,
        legacyBehavior: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandNameTextLink, {
            children: shortenString(brandName)
        })
    });
};
const ProductInfo = (props)=>{
    var ref, ref1, ref2, ref3;
    const { product  } = props;
    const { epicOmni1550 , isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlags */ .g)();
    const theme = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
    const { productRatingData  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useProductDetailState */ .W)();
    const { totalReviews , averageRating  } = productRatingData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                align: "top",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX, {
                        flex: isMobile ? "75%" : "100%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductName, {
                            level: 1,
                            color: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.black,
                            weight: "bold",
                            children: product.displayName
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX, {
                        flex: "25%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .k, {
                            align: "center",
                            justify: "end",
                            gap: "s4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        fontSize: 13,
                                        lineHeight: "20px",
                                        fontWeight: 400
                                    },
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Y\xeau th\xedch")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_11__/* .WishlistButton */ .s, {
                                    sku: product.sku,
                                    size: "24"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ProductInfoWrapper, {
                isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCaption, {
                        level: 1,
                        marginTop: "s4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Thương hiệu:")
                            }),
                            flags.epic_omni_1552 && (product === null || product === void 0 ? void 0 : (ref1 = product.brands) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? product.brands.map((brand, index)=>{
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                                            brandCode: brand.code,
                                            brandName: brand.name
                                        }, "".concat(brand.code).concat(brand.name).concat(index)),
                                        index + 1 !== (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) && ",\xa0"
                                    ]
                                }, index);
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                                brandCode: product === null || product === void 0 ? void 0 : (ref2 = product.brand) === null || ref2 === void 0 ? void 0 : ref2.code,
                                brandName: product === null || product === void 0 ? void 0 : (ref3 = product.brand) === null || ref3 === void 0 ? void 0 : ref3.name
                            })
                        ]
                    }),
                    !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCaption, {
                                level: 1,
                                marginTop: "s4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                                    children: [
                                        "SKU: ",
                                        product.sellerSku || product.sku
                                    ]
                                })
                            }),
                            epicOmni1550 && !!totalReviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .RatingFilled */ .A, {
                                        size: 18,
                                        color: "support"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                        weight: "bold",
                                        margin: [
                                            "s0",
                                            "s4"
                                        ],
                                        children: averageRating
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                        weight: "regular",
                                        color: "#0200bc",
                                        onClick: ()=>(0,helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__/* .scrollSmoothToIdWithOffset */ .A)("review-section", 60),
                                        children: "(".concat(totalReviews, " ").concat((0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("lượt đ\xe1nh gi\xe1"), ")")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const ProductName = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Heading */ .X6)(_templateObject());
const BrandNameTextLink = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].a((param)=>{
    let { theme  } = param;
    var ref;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary, ";\n  font-weight: normal;\n  margin-left: 4px;\n  font-size: 12px;\n  line-height: 16px;\n  text-decoration: none;\n");
});
const StyledCaption = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Caption */ .YS)(_templateObject1());
const Text = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].span(_templateObject2());
const ProductInfoWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject3(), (param)=>{
    let { isMobile  } = param;
    return isMobile ? "flex-start" : "center";
}, (param)=>{
    let { isMobile  } = param;
    return isMobile ? "column" : "row";
});
const Divider = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject4());


/***/ }),

/***/ 825047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ MAX_ITEMS_WITH_TWO_BLOCKS; },
  "E": function() { return /* binding */ ProductNews; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ChevronForwardFilled.es.js
var ChevronForwardFilled_es = __webpack_require__(517293);
// EXTERNAL MODULE: ./components/YoutubeFrame.tsx
var YoutubeFrame = __webpack_require__(742609);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductNews/RelatedBlock.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const RelatedBlock = (props)=>{
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react.useState)();
    const { type , seeMoreUrl , items  } = props;
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            align: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                    height: "113px",
                    cover: true,
                    borderRadius: 8,
                    src: url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                    width: "80%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                        weight: "medium",
                        line: 4,
                        level: 1,
                        marginLeft: "s12",
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
                style: {
                    minHeight: 420
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        gap: "s16",
                        direction: "column",
                        marginTop: "s12",
                        children: items.map((item, index)=>{
                            const { url , thumbnailUrl , description  } = item;
                            return type === "post" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCustomLink, {
                                href: url,
                                target: "_blank",
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                                onClick: ()=>setYoutubeLink(url),
                                style: {
                                    cursor: "pointer",
                                    width: "100%"
                                },
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url));
                        })
                    }),
                    !!seeMoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                            style: {
                                position: "absolute",
                                bottom: 20
                            },
                            align: "center",
                            justify: "center",
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                                variant: "link",
                                children: [
                                    (0,i18n.t)("Xem th\xeam"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardFilled_es/* ChevronForwardFilled */.O, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeFrame.YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const StyledCustomLink = (0,emotion_styled_browser_esm["default"])(CustomLink_es/* CustomLink */.x)(_templateObject());
const IFramePopupWrapper = emotion_styled_browser_esm["default"].div(_templateObject1());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductNews/RelatedPosts.tsx




const RelatedPosts = (param)=>{
    let { relatedPosts ={
        urls: [],
        seeMoreUrl: ""
    }  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedBlock, {
            type: "post",
            seeMoreUrl: relatedPosts.seeMoreUrl,
            items: (relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref = relatedPosts.urls) === null || ref === void 0 ? void 0 : ref.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                let { url , thumbnailUrl , description  } = param;
                return {
                    url: url || "",
                    thumbnailUrl: thumbnailUrl || "",
                    description: description || ""
                };
            })) || []
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(979894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductNews/RelatedVideos.tsx





const RelatedVideos = (param)=>{
    let { relatedVideos ={
        urls: [],
        seeMoreUrl: ""
    }  } = param;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: relatedVideos.urls.map((video, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "VideoObject",
                                name: video.name,
                                description: video.description,
                                thumbnailUrl: video.thumbnailUrl,
                                uploadDate: typeof video.uploadDate === "number" ? new Date(video.uploadDate * 1000).toISOString() : "",
                                embedUrl: video.url
                            })
                        }
                    }, "".concat(index).concat(video.url));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedBlock, {
                type: "video",
                seeMoreUrl: relatedVideos.seeMoreUrl,
                items: (relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref1 = relatedVideos.urls) === null || ref1 === void 0 ? void 0 : ref1.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                    let { url , thumbnailUrl , name  } = param;
                    return {
                        url: url || "",
                        thumbnailUrl: thumbnailUrl || "",
                        description: name || ""
                    };
                })) || []
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductNews/TabItem.tsx
function TabItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TabItem_templateObject() {
    const data = TabItem_taggedTemplateLiteral([
        "\n  padding: 8px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 999px;\n  margin-right: 8px;\n  cursor: pointer;\n"
    ]);
    TabItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




const TabItem = (param)=>{
    let { isActive , onClick , title  } = param;
    const { colors  } = (0,Theme_es/* useTheme */.F)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        style: {
            borderColor: isActive ? colors.primary : colors.border,
            backgroundColor: isActive ? colors.primary100 : "white"
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
            children: title
        })
    });
};
const StyledWrapper = emotion_styled_browser_esm["default"].div(TabItem_templateObject());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductNews/index.tsx
function ProductNews_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductNews_templateObject() {
    const data = ProductNews_taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 16px;\n  padding: 16px;\n  height: 100%;\n"
    ]);
    ProductNews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductNews_templateObject1() {
    const data = ProductNews_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n"
    ]);
    ProductNews_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const ProductNews = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)("POST");
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { relatedPosts , relatedVideos  } = (product === null || product === void 0 ? void 0 : product.seoInfo) || {
        relatedPosts: {
            title: ""
        },
        relatedVideos: {
            title: ""
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (!!(product === null || product === void 0 ? void 0 : (ref = product.seoInfo) === null || ref === void 0 ? void 0 : ref.relatedPosts)) {
            setActiveTab("POST");
            return;
        }
        if (!!(product === null || product === void 0 ? void 0 : (ref1 = product.seoInfo) === null || ref1 === void 0 ? void 0 : ref1.relatedVideos)) {
            setActiveTab("VIDEO");
            return;
        }
        setActiveTab("");
    }, [
        product === null || product === void 0 ? void 0 : product.seoInfo
    ]);
    if (!(product === null || product === void 0 ? void 0 : (ref = product.seoInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.relatedVideos) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.urls) === null || ref2 === void 0 ? void 0 : ref2.length) && !(product === null || product === void 0 ? void 0 : (ref3 = product.seoInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.relatedPosts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.urls) === null || ref5 === void 0 ? void 0 : ref5.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                children: (0,i18n.t)("Tin tức sản phẩm")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    !!(product === null || product === void 0 ? void 0 : (ref6 = product.seoInfo) === null || ref6 === void 0 ? void 0 : ref6.relatedPosts) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                        onClick: ()=>setActiveTab("POST"),
                        isActive: activeTab === "POST",
                        title: (relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.title) || ""
                    }),
                    !!(product === null || product === void 0 ? void 0 : (ref7 = product.seoInfo) === null || ref7 === void 0 ? void 0 : ref7.relatedVideos) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                        onClick: ()=>setActiveTab("VIDEO"),
                        isActive: activeTab === "VIDEO",
                        title: (relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.title) || ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    activeTab === "POST" && (product === null || product === void 0 ? void 0 : (ref8 = product.seoInfo) === null || ref8 === void 0 ? void 0 : ref8.relatedPosts) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPosts, {
                        relatedPosts: product === null || product === void 0 ? void 0 : (ref9 = product.seoInfo) === null || ref9 === void 0 ? void 0 : ref9.relatedPosts
                    }),
                    activeTab === "VIDEO" && (product === null || product === void 0 ? void 0 : (ref10 = product.seoInfo) === null || ref10 === void 0 ? void 0 : ref10.relatedVideos) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedVideos, {
                        relatedVideos: product === null || product === void 0 ? void 0 : (ref11 = product.seoInfo) === null || ref11 === void 0 ? void 0 : ref11.relatedVideos
                    })
                ]
            })
        ]
    });
};
const Wrapper = emotion_styled_browser_esm["default"].div(ProductNews_templateObject());
const StyledHeader = emotion_styled_browser_esm["default"].div(ProductNews_templateObject1());


/***/ }),

/***/ 768439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ProductProviderInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(325710);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  max-width: 105px;\n  font-size: 13px;\n  color: black;\n  font-weight: 400;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 0;\n  border-top: 1px dashed;\n  border-bottom: 1px dashed;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







const ProductProviderInfo = ()=>{
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { colors  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
    const provider = (product === null || product === void 0 ? void 0 : product.provider) || {
        name: "",
        logo: "",
        id: ""
    };
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundColor: colors.white
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSellerCardv, {
            padding: isMobile ? "s8" : "s16",
            style: {
                borderColor: colors.border
            },
            name: provider.name,
            slogan: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewProduct, {
                onClick: ()=>router.replace("/cua-hang/".concat(provider.id, "?pageTitle=").concat(provider.name)),
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Xem sản phẩm")
            }),
            avatar: {
                src: provider.logo || ""
            },
            link: {
                href: "/cua-hang/".concat(provider.id, "?pageTitle=").concat(provider.name)
            },
            showSlogan: true
        })
    });
};
const ViewProduct = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject());
const StyledSellerCardv = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .SellerCard */ .S)(_templateObject1());


/***/ }),

/***/ 42927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ ProductUnitAndPrice; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../packages/types/dist/shared/index.es.js + 1 modules
var shared_index_es = __webpack_require__(184019);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductVariantRow.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  margin-bottom: 2px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  opacity: ",
        ";\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 400;\n  min-width: 56px;\n  max-width: 74px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: -1px;\n  width: 18px;\n  height: 18px;\n  background: #0200bc;\n  border-bottom-right-radius: 8px;\n  clip-path: polygon(100% 0, 0 100%, 100% 100%);\n\n  &::after {\n    content: '✔';\n    position: absolute;\n    bottom: -4px;\n    right: 2px;\n    font-size: 9px;\n    color: #fff;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  cursor: pointer;\n  opacity: ",
        ";\n  position: relative;\n  transition: background 0.2s ease, opacity 0.2s ease;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  text-decoration: line-through;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 24px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1.5px solid ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  width: 8px;\n  height: 8px;\n  background: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






const VariantRow = (param)=>{
    let { row , isUomRow =false , showImage =false ,  } = param;
    const { numberDisplayFormat , isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onSelectVariant , variants  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const baseUomLabel = (0,react.useMemo)(()=>{
        var ref;
        if (!isUomRow) return undefined;
        return (ref = row.options.find((opt)=>opt.uomRatio === 1)) === null || ref === void 0 ? void 0 : ref.label;
    }, [
        isUomRow,
        row.options
    ]);
    const sortedOptions = (0,react.useMemo)(()=>{
        if (!isUomRow) return row.options;
        var _uomRatio, _uomRatio1;
        return [
            ...row.options
        ].sort((a, b)=>((_uomRatio = a.uomRatio) !== null && _uomRatio !== void 0 ? _uomRatio : 0) - ((_uomRatio1 = b.uomRatio) !== null && _uomRatio1 !== void 0 ? _uomRatio1 : 0));
    }, [
        isUomRow,
        row.options
    ]);
    const getFormattedPrice = (0,react.useCallback)((price, isIncludeUnit)=>typeof price === "number" ? (0,number_es/* formatCurrency */.xG)(price, numberDisplayFormat, isIncludeUnit) : price, [
        numberDisplayFormat
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
        justify: "start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantTitle, {
                width: "100%",
                level: 1,
                marginTop: "s8",
                children: [
                    row.title,
                    isUomRow ? ":" : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                justify: "start",
                align: "middle",
                width: "100%",
                children: sortedOptions.map((opt, index)=>{
                    const variantPrices = isUomRow ? variants === null || variants === void 0 ? void 0 : variants.find((variant)=>variant.sku === opt.sku) : undefined;
                    const isBaseUom = opt.uomRatio === 1;
                    const blur = opt.quantity === 0;
                    const formattedRetailPrice = getFormattedPrice(variantPrices === null || variantPrices === void 0 ? void 0 : variantPrices.supplierRetailPrice, false);
                    const formattedLatestPrice = getFormattedPrice(variantPrices === null || variantPrices === void 0 ? void 0 : variantPrices.rowTotal);
                    const baseUnitPrice = getFormattedPrice(variantPrices === null || variantPrices === void 0 ? void 0 : variantPrices.baseUnitPrice);
                    return isUomRow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UomRow, {
                        selected: opt.selected,
                        blur: blur,
                        onClick: ()=>onSelectVariant(opt),
                        padding: [
                            "s4",
                            "s8"
                        ],
                        marginBottom: "s8",
                        borderRadius: "m",
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            align: "middle",
                            justify: "space-between",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    align: "middle",
                                    style: {
                                        columnGap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOuter, {
                                            selected: opt.selected,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInner, {
                                                selected: opt.selected
                                            })
                                        }),
                                        !!opt.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                            src: opt.imageUrl,
                                            alt: opt.label,
                                            imageWidth: 24,
                                            borderRadius: "4px",
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                opt.label,
                                                " ",
                                                !isBaseUom && !!baseUomLabel && "".concat(opt.uomRatio, " ").concat(baseUomLabel)
                                            ]
                                        })
                                    ]
                                }),
                                opt.quantity !== 0 && !!variantPrices && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: isMobile ? "column" : "row",
                                    gapX: "s4",
                                    align: isMobile ? "end" : "center",
                                    justify: "end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                            direction: "row",
                                            align: "center",
                                            justify: "end",
                                            gap: "s4",
                                            children: [
                                                !!variantPrices.discountPercent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Discount, {
                                                            color: "error",
                                                            children: [
                                                                "-",
                                                                variantPrices.discountPercent,
                                                                "%"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RetailedPrice, {
                                                            color: "disable",
                                                            children: formattedRetailPrice
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                                    children: formattedLatestPrice
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                            align: "middle",
                                            justify: "end",
                                            children: !!(variantPrices === null || variantPrices === void 0 ? void 0 : variantPrices.baseUnitPrice) && !isBaseUom && /*#__PURE__*/ (0,jsx_runtime.jsx)(BasePrice, {
                                                color: "textSecondary",
                                                children: "(".concat(baseUnitPrice, "/").concat(baseUomLabel, ")")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantButton, {
                        selected: opt.selected,
                        onClick: ()=>onSelectVariant(opt),
                        height: "min-content",
                        borderRadius: "m",
                        blur: blur,
                        marginRight: "s8",
                        padding: [
                            "s4",
                            "s8"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "column",
                                gap: "s8",
                                justify: "center",
                                align: "center",
                                children: [
                                    !!opt.imageUrl && !!showImage && //Only show image of first attribute variant
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                        src: opt.imageUrl,
                                        alt: opt.label,
                                        imageWidth: 48,
                                        width: 48,
                                        height: 48
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                        height: "32px",
                                        align: "center",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantButtonLabel, {
                                            children: opt.label
                                        })
                                    })
                                ]
                            }),
                            opt.selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Corner, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
const VariantTitle = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject());
const VariantButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(_templateObject1(), (param)=>{
    let { selected  } = param;
    return selected ? "#0200BC" : "#CCC";
}, (param)=>{
    let { blur  } = param;
    return blur ? 0.5 : 1;
}, (param)=>{
    let { blur  } = param;
    return blur ? "#CCC" : "#0200BC";
}, (param)=>{
    let { blur  } = param;
    return blur && "\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: rgba(255, 255, 255, 0.5);\n      border-radius: inherit;\n    }\n  ";
});
const VariantButtonLabel = emotion_styled_browser_esm["default"].span(_templateObject2());
const Corner = emotion_styled_browser_esm["default"].div(_templateObject3());
const UomRow = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)(_templateObject4(), (param)=>{
    let { selected  } = param;
    return selected ? "#0200BC0D" : "#fff";
}, (param)=>{
    let { blur  } = param;
    return blur ? 0.5 : 1;
}, (param)=>{
    let { blur  } = param;
    return blur && "\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: rgba(255, 255, 255, 0.5);\n      border-radius: inherit;\n    }\n  ";
});
const Discount = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject5());
const RetailedPrice = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject6());
const Price = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject7());
const BasePrice = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject8());
const RadioOuter = emotion_styled_browser_esm["default"].div(_templateObject9(), (param)=>{
    let { selected  } = param;
    return selected ? "#0200bc" : "#aaa";
});
const RadioInner = emotion_styled_browser_esm["default"].div(_templateObject10(), (param)=>{
    let { selected  } = param;
    return selected ? "#0200bc" : "transparent";
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
;// CONCATENATED MODULE: ./modules/product-detail/shared/UomItem.tsx
function UomItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UomItem_templateObject() {
    const data = UomItem_taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-block;\n  padding: 8px;\n  border: 1px solid #0200bc; /* viền xanh */\n  border-radius: 8px; /* bo g\xf3c */\n  background: #fff;\n  font-size: 16px;\n  color: #000;\n  cursor: pointer;\n  overflow: hidden;\n  min-width: 72px;\n  height: 36px;\n\n  .corner {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 17px;\n    height: 17px;\n    background: #0200bc; /* m\xe0u g\xf3c gấp */\n    clip-path: polygon(100% 0, 0 100%, 100% 100%);\n  }\n  .corner::after {\n    content: '✔';\n    position: absolute;\n    bottom: -4px;\n    right: 3px;\n    font-size: 8px;\n    color: #fff; /* dấu check trắng */\n  }\n"
    ]);
    UomItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




const UomItem = ()=>{
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                level: 1,
                children: product === null || product === void 0 ? void 0 : product.uomName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "corner"
            })
        ]
    });
};
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(UomItem_templateObject());

// EXTERNAL MODULE: ./modules/product-detail/hooks/useGetPriceDetailPage.ts
var useGetPriceDetailPage = __webpack_require__(906825);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductUnitAndPrice.tsx
function ProductUnitAndPrice_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductUnitAndPrice_templateObject() {
    const data = ProductUnitAndPrice_taggedTemplateLiteral([
        "\n  gap: 16px;\n"
    ]);
    ProductUnitAndPrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductUnitAndPrice_templateObject1() {
    const data = ProductUnitAndPrice_taggedTemplateLiteral([
        "\n  height: auto;\n  .att-product-detail-latest-price {\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n  .att-product-detail-retail-price {\n    font-size: 13px;\n  }\n"
    ]);
    ProductUnitAndPrice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const ProductUnitAndPrice = ()=>{
    const { isDisplayUom , numberDisplayFormat , isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { product , price , setIsReturnVariants  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { calculatePrice  } = (0,useGetPriceDetailPage/* useGetPriceDetailPage */.P)();
    const productOptions = product === null || product === void 0 ? void 0 : product.productOptions;
    const { uomRow , attributeRows  } = (0,react.useMemo)(()=>{
        const rows = (productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows) || [];
        return {
            uomRow: rows.find((row)=>row.code === "uom"),
            attributeRows: rows.filter((row)=>row.code !== "uom")
        };
    }, [
        productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows
    ]);
    const hasUomRow = !!uomRow && uomRow.options.length > 1;
    (0,react.useEffect)(()=>{
        setIsReturnVariants === null || setIsReturnVariants === void 0 ? void 0 : setIsReturnVariants(hasUomRow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUomRow
    ]);
    const renderUomSection = ()=>{
        if (hasUomRow) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantRow, {
                row: uomRow,
                isUomRow: true
            });
        }
        if (isDisplayUom && (product === null || product === void 0 ? void 0 : product.uomName)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                direction: "column",
                backgroundColor: "white",
                gap: "s4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                        style: {
                            fontSize: 14,
                            fontWeight: 400,
                            lineHeight: "22px"
                        },
                        children: [
                            (0,i18n.t)("Đơn vị"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UomItem, {})
                ]
            });
        }
        return null;
    };
    if (!productOptions) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantsBlock, {
                children: [
                    !!(attributeRows === null || attributeRows === void 0 ? void 0 : attributeRows.length) && attributeRows.map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(VariantRow, {
                            row: row,
                            showImage: i === 0
                        }, i)),
                    renderUomSection()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                dividerStyle: shared_index_es/* DividerStyleEnum.dashed */.fd.dashed,
                backgroundColor: "white",
                color: "divider",
                padding: "s0"
            }),
            !hasUomRow && !!(price === null || price === void 0 ? void 0 : price.finalPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                backgroundColor: "white",
                marginBottom: isMobile ? "s0" : "s8",
                children: !!(price === null || price === void 0 ? void 0 : price.finalPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductPrice, {
                    isMobile: isMobile,
                    discountPercent: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.discountPercent,
                    latestPrice: (0,number_es/* formatCurrency */.xG)(price === null || price === void 0 ? void 0 : price.finalPrice, numberDisplayFormat) || "",
                    supplierRetailPrice: (0,number_es/* formatCurrency */.xG)(calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.supplierRetailPrice, numberDisplayFormat) || "",
                    size: "l"
                })
            })
        ]
    });
};
const VariantsBlock = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(ProductUnitAndPrice_templateObject());
const StyledProductPrice = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(ProductUnitAndPrice_templateObject1(), (param)=>{
    let { isMobile  } = param;
    return isMobile ? "24px" : "32px";
}, (param)=>{
    let { isMobile  } = param;
    return isMobile ? "32px" : "40px";
});


/***/ }),

/***/ 555082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ReviewSection": function() { return /* binding */ ReviewSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ui_review__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(885541);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(983546);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(842918);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  .title {\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = (param)=>{
    let { product , wrapperBorderRadius  } = param;
    var ref, ref1;
    const { colors , borderRadius  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)();
    const { tekReviewAppId  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { user , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)();
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    if (!tekReviewAppId) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        wrapperBorderRadius: wrapperBorderRadius,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBlockHeader, {
                title: "Đ\xe1nh gi\xe1 sản phẩm",
                borderColor: "#ebeaea"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui_review__WEBPACK_IMPORTED_MODULE_1__/* .TekReview */ .O, {
                appId: tekReviewAppId,
                entity: {
                    key: product.sku,
                    imageUrl: ((ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                    title: product.name
                },
                theme: {
                    colors: {
                        primary: colors.primary,
                        primaryActive: colors.primary600,
                        primaryHover: colors.primary700
                    },
                    borderRadius: borderRadius.s
                },
                reviewer: user ? {
                    displayName: user.name,
                    avatarUrl: user.avatar,
                    email: user.email,
                    phoneNumber: user.telephone
                } : undefined,
                onRequestLogin: ()=>setShow(true)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Modal */ .u, {
                visible: show,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Hủy"),
                onOk: ()=>{
                    authService === null || authService === void 0 ? void 0 : authService.login(window.location.href);
                },
                onCancel: ()=>{
                    setShow(false);
                },
                footer: true,
                onBackDrop: ()=>setShow(false),
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
            })
        ]
    });
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div((param)=>{
    let { wrapperBorderRadius  } = param;
    return "\n  position: relative;\n  background-color: #fff;\n  margin-top: 8px;\n  margin-bottom: 0.5rem;\n  border-radius: ".concat(wrapperBorderRadius || "0px", ";\n");
});
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .BlockHeader */ .t)(_templateObject(), (props)=>props.borderColor);


/***/ }),

/***/ 716955:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("https://shopfront-cdn.tekoapis.com/_next/static/images/combo-promotion-v2-de90f005727a664a24f4d737d49a336d.svg");

/***/ })

}]);